import { render, staticRenderFns } from "./GiftCardReports.vue?vue&type=template&id=26c1cb8c&scoped=true"
import script from "./GiftCardReports.vue?vue&type=script&lang=js"
export * from "./GiftCardReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c1cb8c",
  null
  
)

export default component.exports